import { useState } from 'react';
import './CommercialFAQ.css';

const faqs = [
  {
    q: 'Will a battery provide backup power during an outage?',
    a: 'This depends on the system design. Some commercial battery systems can provide backup power to selected circuits or critical loads.',
  },
  {
    q: 'What size battery does my business need?',
    a: 'Battery size depends on your energy consumption, peak demand periods, and goals. We assess your usage data and recommend a system tailored to your business.',
  },
  {
    q: 'Will installation disrupt my business operations?',
    a: 'Most installations are designed to minimise disruption. Our team works with you to schedule installation during off-peak hours where possible.',
  },
  {
    q: 'Can I expand the battery system in the future?',
    a: 'Yes. Many commercial battery systems are modular and designed to scale as your energy needs grow.',
  },
  {
    q: 'Is a site inspection required?',
    a: 'Yes, a site assessment is required to determine the best system configuration, connection points, and equipment placement for your premises.',
  },
  {
    q: 'How long does installation take?',
    a: 'Installation timeframes vary depending on system size and site complexity. Most commercial installations are completed within one to three days.',
  },
];

// FAQPage structured data, generated from the same FAQ list shown on the page
const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: { '@type': 'Answer', text: a },
  })),
};

export default function CommercialFAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="cfaq-section">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="cfaq-inner">

        {/* Left dark card */}
        <div className="cfaq-left">
          <h2 className="cfaq-left-title">FAQ</h2>
          <div className="cfaq-left-underline" />
          <p className="cfaq-left-desc">
            Find answers to the most common questions about commercial battery systems.
          </p>
          <div className="cfaq-left-icon">
            <svg width="140" height="140" viewBox="0 0 64 64" fill="none">
              <rect x="8" y="18" width="48" height="38" rx="4" stroke="#eaff50" strokeWidth="2.5" />
              <rect x="20" y="10" width="8" height="10" rx="2" stroke="#eaff50" strokeWidth="2.5" />
              <rect x="36" y="10" width="8" height="10" rx="2" stroke="#eaff50" strokeWidth="2.5" />
              <path d="M36 29l-8 12h8l-8 12" stroke="#eaff50" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>

        {/* Right accordion */}
        <div className="cfaq-right">
          {faqs.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={i} className={`cfaq-item${isOpen ? ' cfaq-item--open' : ''}`}>
                <button className="cfaq-item-header" onClick={() => toggle(i)}>
                  <span className="cfaq-item-q">
                    <span className="cfaq-item-num">{i + 1}.</span>
                    {item.q}
                  </span>
                  <svg
                    className={`cfaq-chevron${isOpen ? ' cfaq-chevron--open' : ''}`}
                    width="18" height="18" viewBox="0 0 24 24" fill="none"
                  >
                    <path d="M6 9l6 6 6-6" stroke="#eaff50" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
                <div className="cfaq-item-body">
                  <p className="cfaq-item-a">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
